import { render } from "./AdminUso.vue?vue&type=template&id=73261421&scoped=true"
import script from "./AdminUso.vue?vue&type=script&lang=js"
export * from "./AdminUso.vue?vue&type=script&lang=js"

import "./AdminUso.vue?vue&type=style&index=0&id=73261421&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73261421"]])

export default __exports__